import { Link } from "react-router-dom";

import { Seo } from "@/components/seo/Seo";

export function NotFoundPage() {
  return (
    <>
      <Seo
        path="/404"
        title="Page Not Found | VideoTranscriptSaver"
        description="The requested page could not be found."
        robots="noindex,nofollow"
      />
      <section className="mx-auto max-w-3xl px-4 py-16 text-center sm:px-6">
        <h1 className="text-4xl font-semibold">Page not found</h1>
        <p className="mt-3 text-neutral-600 dark:text-neutral-400">The transcript tool is still ready on the homepage.</p>
        <Link
          to="/"
          className="mt-6 inline-flex h-10 items-center border border-neutral-950 bg-neutral-950 px-4 text-sm font-medium text-white dark:border-white dark:bg-white dark:text-neutral-950"
        >
          Open tool
        </Link>
      </section>
    </>
  );
}
